export default __webpack_public_path__ + "static/media/Leaders_IMG-ChanYoon.11759c3f.png";